import { render, staticRenderFns } from "./WizardLocationServiceTour.vue?vue&type=template&id=3b925962&"
import script from "./WizardLocationServiceTour.vue?vue&type=script&lang=js&"
export * from "./WizardLocationServiceTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports